import { useState } from "react";
import { Copy, Check, ExternalLink, Mail } from "lucide-react";
import { BrandLogo } from "@/components/icons/brand-logo";
export function ContactMethods() {
  const [copied, setCopied] = useState(false);

  const email = "poly@poly186.io";

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy email: ", err);
    }
  };

  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/company/poly186', '_blank', 'noopener,noreferrer');
  };

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/thepolyagency/', '_blank', 'noopener,noreferrer');
  };

  const handleTikTokClick = () => {
    window.open('https://www.tiktok.com/@theagencyofpoly', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex flex-col gap-4 mt-8">
      {/* Email Row */}
      <div className="group flex items-center gap-4 p-4 rounded-2xl border border-border transition-all hover:border-primary/40 hover:transform hover:-translate-y-0.5">
        <div className="w-12 h-12 rounded-lg border border-border group-hover:border-primary/40 transition-colors flex items-center justify-center flex-shrink-0">
          <Mail className="w-6 h-6 text-foreground" aria-hidden="true" />
        </div>
        <span className="font-body text-foreground flex-1">
          {email}
        </span>
        <button
          onClick={handleCopyEmail}
          className="w-10 h-10 rounded-lg flex items-center justify-center hover:bg-accent cursor-pointer transition-colors"
          aria-label="Copy email address"
        >
          {copied ? (
            <Check className="w-5 h-5 text-green-500" />
          ) : (
            <Copy className="w-5 h-5 text-muted-foreground hover:text-foreground" />
          )}
        </button>
      </div>

      {/* LinkedIn Row */}
      <div className="group flex items-center gap-4 p-4 rounded-2xl border border-border transition-all hover:border-primary/40 hover:transform hover:-translate-y-0.5">
        <div className="w-12 h-12 rounded-lg border border-border group-hover:border-primary/40 transition-colors flex items-center justify-center flex-shrink-0">
          <BrandLogo name="linkedin" className="w-6 h-6 text-foreground" />
        </div>
        <span className="font-body text-foreground flex-1 text-left">
          Poly186 AI DAO
        </span>
        <button
          onClick={handleLinkedInClick}
          className="w-10 h-10 rounded-lg flex items-center justify-center hover:bg-accent cursor-pointer transition-colors"
          aria-label="Open LinkedIn profile"
        >
          <ExternalLink className="w-5 h-5 text-muted-foreground hover:text-foreground" />
        </button>
      </div>

      {/* Instagram Row */}
      <div className="group flex items-center gap-4 p-4 rounded-2xl border border-border transition-all hover:border-primary/40 hover:transform hover:-translate-y-0.5">
        <div className="w-12 h-12 rounded-lg border border-border group-hover:border-primary/40 transition-colors flex items-center justify-center flex-shrink-0">
          <BrandLogo name="instagram" className="w-6 h-6 text-foreground" />
        </div>
        <span className="font-body text-foreground flex-1 text-left">
          @thepolyagency
        </span>
        <button
          onClick={handleInstagramClick}
          className="w-10 h-10 rounded-lg flex items-center justify-center hover:bg-accent cursor-pointer transition-colors"
          aria-label="Open Instagram profile"
        >
          <ExternalLink className="w-5 h-5 text-muted-foreground hover:text-foreground" />
        </button>
      </div>

      {/* TikTok Row */}
      <div className="group flex items-center gap-4 p-4 rounded-2xl border border-border transition-all hover:border-primary/40 hover:transform hover:-translate-y-0.5">
        <div className="w-12 h-12 rounded-lg border border-border group-hover:border-primary/40 transition-colors flex items-center justify-center flex-shrink-0">
          <BrandLogo name="tiktok" className="w-6 h-6 text-foreground" />
        </div>
        <span className="font-body text-foreground flex-1 text-left">
          @theagencyofpoly
        </span>
        <button
          onClick={handleTikTokClick}
          className="w-10 h-10 rounded-lg flex items-center justify-center hover:bg-accent cursor-pointer transition-colors"
          aria-label="Open TikTok profile"
        >
          <ExternalLink className="w-5 h-5 text-muted-foreground hover:text-foreground" />
        </button>
      </div>
    </div>
  );
}